import { render } from "./OrientationBatch.vue?vue&type=template&id=591daa32"
import script from "./OrientationBatch.vue?vue&type=script&lang=js"
export * from "./OrientationBatch.vue?vue&type=script&lang=js"

import "./OrientationBatch.vue?vue&type=style&index=0&id=591daa32&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__